import { ACCEPTANCE_STATUS } from '../api/events';
import { COLORS } from '../theme/variables';

export function getAttendanceStatusColor(status: ACCEPTANCE_STATUS) {
  switch (status) {
    case ACCEPTANCE_STATUS.GREEN:
      return COLORS.COLOR_GREEN_BASE;
    case ACCEPTANCE_STATUS.YELLOW:
      return COLORS.COLOR_ADDITIONAL_ORANGE;
    case ACCEPTANCE_STATUS.RED:
      return COLORS.COLOR_RED_BASE;
    case ACCEPTANCE_STATUS.GRAY:
    default:
      return COLORS.COLOR_GRAY_BASE;
  }
}
